import { render, staticRenderFns } from "./QbillItem.vue?vue&type=template&id=f8c3f4ec"
import script from "./QbillItem.vue?vue&type=script&lang=js"
export * from "./QbillItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_84f1f4618b294cfa2aad13d74ae0562d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports